/* SAGLOU · V4 · Burger (menú móvil)
   El encabezado abre y cierra el menú (.is-open, Escape, bloqueo del desplazamiento).
   Este script añade: niveles con «Volver», foco contenido mientras está abierto, devolución
   del foco al botón que lo abrió, marca de la página actual y continuidad: si se entra en una
   página desde un nivel, al volver a abrir el menú en la misma sesión se muestra ese nivel. */
(function () {
  'use strict';

  var KEY = 'sgb-last';

  function init(menu) {
    if (!menu || menu.__sgb) return;
    menu.__sgb = true;

    var panels = Array.prototype.slice.call(menu.querySelectorAll('[data-sgb-panel]'));
    var root = menu.querySelector('[data-sgb-panel="root"]');
    var where = menu.querySelector('[data-sgb-where]');
    var toggle = document.querySelector('.sg-header__mobile-toggle');
    var current = root;
    var opener = null;
    var navigating = false;

    panels.forEach(function (p) { p.removeAttribute('hidden'); setInert(p, p !== root); });

    function setInert(p, on) {
      if (on) { p.setAttribute('inert', ''); p.setAttribute('aria-hidden', 'true'); }
      else { p.removeAttribute('inert'); p.removeAttribute('aria-hidden'); }
    }

    function show(name, focusTarget) {
      var next = menu.querySelector('[data-sgb-panel="' + name + '"]') || root;
      panels.forEach(function (p) {
        var on = p === next;
        p.classList.toggle('is-active', on);
        setInert(p, !on);
      });
      menu.querySelectorAll('[data-sgb-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', b.getAttribute('data-sgb-open') === name ? 'true' : 'false');
      });
      current = next;
      if (where) where.textContent = next.getAttribute('data-sgb-title') || '';
      if (focusTarget) focusSoon(focusTarget);
    }

    /* El menú se hace visible con una transición: reintentar hasta que el foco entre. */
    function focusSoon(el) {
      var tries = 0;
      (function attempt() {
        if (!menu.classList.contains('is-open') || el.closest('[inert]')) return;
        el.focus({ preventScroll: true });
        if (document.activeElement !== el && ++tries < 12) window.setTimeout(attempt, 50);
      })();
    }

    menu.querySelectorAll('[data-sgb-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        opener = b;
        var name = b.getAttribute('data-sgb-open');
        var panel = menu.querySelector('[data-sgb-panel="' + name + '"]');
        panel.scrollTop = 0;
        show(name, panel.querySelector('.sgb__h') || panel);
      });
    });

    menu.querySelectorAll('[data-sgb-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        var from = current.getAttribute('data-sgb-panel');
        show('root', menu.querySelector('[data-sgb-open="' + from + '"]'));
      });
    });

    /* Gesto: deslizar a la derecha en un segundo nivel vuelve al menú */
    var x0 = 0, y0 = 0;
    menu.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    menu.addEventListener('touchend', function (e) {
      if (current === root) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (dx > 70 && Math.abs(dx) > Math.abs(dy) * 1.6) {
        var from = current.getAttribute('data-sgb-panel');
        show('root', menu.querySelector('[data-sgb-open="' + from + '"]'));
      }
    }, { passive: true });

    /* Página actual */
    var here = window.location.pathname.replace(/\/$/, '');
    var currentView = new URLSearchParams(window.location.search).get('view') || '';
    var currentLabel = menu.getAttribute('data-sgb-current-label') || '';
    menu.querySelectorAll('a[href]').forEach(function (a) {
      var path = a.pathname ? a.pathname.replace(/\/$/, '') : '';
      var linkView = new URLSearchParams(a.search).get('view') || '';
      if (path && path === here && a.origin === window.location.origin && linkView === currentView && !a.hash && !a.search.includes('zona=')) {
        a.setAttribute('aria-current', 'page');
        var slot = a.querySelector('.sgb__cat-txt, .sgb__row-main') || (a.classList.contains('sgb__tile') ? a : null);
        if (slot) {
          var marker = document.createElement('span');
          marker.className = 'sgb__current';
          marker.textContent = currentLabel;
          slot.appendChild(marker);
        }
        var parent = a.closest('[data-sgb-panel]');
        if (parent && parent !== root) {
          var entry = menu.querySelector('[data-sgb-open="' + parent.getAttribute('data-sgb-panel') + '"] .sgb__row-main');
          if (entry && !entry.querySelector('.sgb__current')) {
            var context = document.createElement('span');
            context.className = 'sgb__current';
            var name = a.querySelector('b');
            context.textContent = currentLabel + (name ? ' · ' + name.textContent : '');
            entry.appendChild(context);
          }
        }
      }
      /* Continuidad: recordar el nivel desde el que se navega */
      a.addEventListener('click', function () {
        navigating = true;
        try { sessionStorage.setItem(KEY, current.getAttribute('data-sgb-panel')); } catch (err) {}
      });
    });

    /* Bolsa desde el menú: cerrar el menú antes de que se abra el carrito (assets/saglou-cart.js),
       para que el carrito quede delante y el foco no vuelva al botón del menú. */
    var toCart = false;
    window.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('.sg-header__mobile-cart');
      if (!chip || !menu.contains(chip) || !menu.classList.contains('is-open')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      toCart = true;
      var close = menu.querySelector('.sg-mobile-menu__close');
      if (close) close.click();
    }, true);

    /* Foco contenido mientras el menú está abierto */
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current !== root) {
        e.stopPropagation();
        var from = current.getAttribute('data-sgb-panel');
        show('root', menu.querySelector('[data-sgb-open="' + from + '"]'));
        return;
      }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.slice.call(menu.querySelectorAll('.sgb__top a, .sgb__top button, .sgb__panel.is-active a, .sgb__panel.is-active button')).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }, true);

    /* Apertura y cierre (los gestiona el encabezado): foco al abrir y devolución al cerrar */
    var wasOpen = false;
    new MutationObserver(function () {
      var open = menu.classList.contains('is-open');
      if (open === wasOpen) return;
      wasOpen = open;
      if (open) {
        var last = null;
        try { last = sessionStorage.getItem(KEY); } catch (err) {}
        try { sessionStorage.removeItem(KEY); } catch (err) {}
        if (last && last !== 'root' && menu.querySelector('[data-sgb-panel="' + last + '"]')) {
          var p = menu.querySelector('[data-sgb-panel="' + last + '"]');
          show(last, p.querySelector('.sgb__h'));
        } else {
          show('root', menu.querySelector('.sgb__close'));
        }
      } else {
        /* Al cerrar sin navegar, el siguiente menú empieza en el nivel principal */
        if (!navigating) { try { sessionStorage.removeItem(KEY); } catch (err) {} }
        navigating = false;
        if (toCart) { toCart = false; return; }
        var active = document.activeElement;
        if (toggle && (!active || active === document.body || menu.contains(active))) toggle.focus({ preventScroll: true });
      }
    }).observe(menu, { attributes: true, attributeFilter: ['class'] });

    /* El menú deja de existir visualmente en escritorio: liberar el bloqueo del encabezado. */
    var mobileViewport = window.matchMedia('(max-width: 749px)');
    function onViewportChange(e) {
      if (e.matches || !menu.classList.contains('is-open')) return;
      var closeButton = menu.querySelector('.sg-mobile-menu__close');
      if (closeButton) closeButton.click();
      var desktopTrigger = document.querySelector('.sg-header__products-trigger');
      if (desktopTrigger && desktopTrigger.offsetParent !== null) desktopTrigger.focus({ preventScroll: true });
    }
    if (mobileViewport.addEventListener) mobileViewport.addEventListener('change', onViewportChange);
    else mobileViewport.addListener(onViewportChange);
  }

  /* Menú de escritorio: Escape cierra y devuelve el foco; salir con el tabulador también cierra */
  function initMega(box) {
    if (!box || box.__sgm) return;
    box.__sgm = true;
    var trigger = box.querySelector('.sg-header__products-trigger');
    function close(focus) {
      box.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (focus && trigger) trigger.focus();
    }
    box.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) { e.preventDefault(); close(true); }
    });
    box.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !box.contains(e.relatedTarget)) close(false);
    });
    if (trigger) {
      var panel = box.querySelector('.sg-header__dropdown');
      if (panel && !panel.id) panel.id = 'sg-header-dropdown';
      if (panel) trigger.setAttribute('aria-controls', panel.id);
    }
  }

  function boot() {
    document.querySelectorAll('[data-sgb]').forEach(init);
    document.querySelectorAll('.sg-header__products').forEach(initMega);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
